// Environment configuration for the application
// This centralizes all configuration values and makes them easily configurable

export const ENV_CONFIG = {
  PROD_URL: "https://pdf-renderer-570770707801.asia-south1.run.app",
  DEV_URL: "http://localhost:8080",
  // API Configuration
  API_BASE_URL: process.env.REACT_APP_API_URL || `https://pdf-renderer-570770707801.asia-south1.run.app/v1/crm`,
  EIRA_API_BASE_URL:
    process.env.REACT_APP_EIRA_API_URL || `https://pdf-renderer-570770707801.asia-south1.run.app/v1/eira`,

  // Business Logic Configuration
  COST_PRICE_MARKUP: parseFloat(
    process.env.REACT_APP_COST_PRICE_MARKUP || "0.8"
  ), // 20% markup
  PAYMENT_TOLERANCE: parseFloat(
    process.env.REACT_APP_PAYMENT_TOLERANCE || "0.01"
  ), // Allow for small floating point differences
  DATABASE_UPDATE_DELAY: parseInt(
    process.env.REACT_APP_DATABASE_UPDATE_DELAY || "1000"
  ), // 1 second delay for database updates

  // Receipt Configuration
  RECEIPT_PREFIX: process.env.REACT_APP_RECEIPT_PREFIX || "RCP-",
  DEFAULT_STORE_NAME:
    process.env.REACT_APP_DEFAULT_STORE_NAME || "Medicine Store",
  DEFAULT_LOCATION: process.env.REACT_APP_DEFAULT_LOCATION || "Branch Location",
  DEFAULT_CONTACT:
    process.env.REACT_APP_DEFAULT_CONTACT || "Contact Information",

  // UI Configuration
  DEBOUNCE_DELAY: parseInt(process.env.REACT_APP_DEBOUNCE_DELAY || "300"), // 300ms debounce delay
  PAGINATION_DEFAULT_PAGE_SIZE: parseInt(
    process.env.REACT_APP_PAGINATION_DEFAULT_PAGE_SIZE || "10"
  ),
  PAGINATION_PAGE_SIZE_OPTIONS: (
    process.env.REACT_APP_PAGINATION_PAGE_SIZE_OPTIONS || "5,10,20,50"
  )
    .split(",")
    .map(Number),

  // Low Stock Configuration
  LOW_STOCK_THRESHOLD: parseInt(
    process.env.REACT_APP_LOW_STOCK_THRESHOLD || "40"
  ),

  // Request Configuration
  REQUEST_TIMEOUT: parseInt(process.env.REACT_APP_REQUEST_TIMEOUT || "10000"), // 10 seconds

  // Development Configuration
  IS_DEVELOPMENT: process.env.NODE_ENV === "development",
  IS_PRODUCTION: process.env.NODE_ENV === "production",
};

// Validation function to ensure required environment variables are set
export const validateEnvironment = () => {
  const requiredVars = ["REACT_APP_API_URL", "REACT_APP_EIRA_API_URL"];

  const missingVars = requiredVars.filter((varName) => !process.env[varName]);

  if (missingVars.length > 0 && ENV_CONFIG.IS_PRODUCTION) {
    console.warn("Missing environment variables:", missingVars);
    console.warn(
      "Using fallback values for production. Please set these environment variables."
    );
  }

  return missingVars.length === 0;
};

// Initialize validation
validateEnvironment();
